module.exports = __webpack_public_path__ + "static/img/bg-en.a610f003.png";